export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/Polygon.13a394be.svg","height":15,"width":18,"blurWidth":0,"blurHeight":0};